import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const DdosProTips = () => {
  const { language } = useLanguage();
  const isEn = language === 'en';

  const tips = [
    {
      titleRu: 'Векторы L4 против L7',
      titleEn: 'L4 vs L7 Vectors',
      descRu:
        'Сетевой флуд (SYN/UDP) нацелен на исчерпание полосы пропускания хостинга. В то же время боты L7 симулируют легитимных клиентов и перегружают процессорные ядра (CPU tick / TPS drop), обходя классические фаерволы.',
      descEn:
        'Network flood (SYN/UDP) aims to exhaust hosting network bandwidth. Meanwhile, L7 bots simulate legitimate clients and overload server CPU cores (CPU tick / TPS drop), bypassing traditional firewalls.',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <rect width="18" height="18" x="3" y="3" rx="2" />
          <path d="m9 8 6 4-6 4Z" />
        </svg>
      ),
      watermark: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3">
          <rect width="18" height="18" x="3" y="3" rx="2" />
          <path d="m9 8 6 4-6 4Z" />
        </svg>
      )
    },
    {
      titleRu: 'Пороги деградации RTT',
      titleEn: 'RTT Degradation Thresholds',
      descRu:
        'Базовый пинг сервера обычно равен 20–40 ms. Рост задержки свыше 250 ms говорит о переполнении буферов Netty. При достижении 500+ ms начинается рассинхронизация пакетов движения и дисконнекты.',
      descEn:
        'Baseline server ping is typically 20–40 ms. Latency spikes above 250 ms indicate Netty buffer overruns. Reaching 500+ ms leads to player movement packet desynchronization and mass disconnects.',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 16 14" />
        </svg>
      ),
      watermark: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3">
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 16 14" />
        </svg>
      )
    },
    {
      titleRu: 'BungeeGuard и защита',
      titleEn: 'BungeeGuard & Defense',
      descRu:
        'Для защиты бэкенд-серверов настройте защищенные токены в связке BungeeGuard/Velocity. Обязательно блокируйте прямые порты Paper/Purpur на уровне локального фаервола iptables или UFW, оставив открытыми только прокси.',
      descEn:
        'To shield backend servers, configure secure forwarding tokens via BungeeGuard/Velocity. Always drop direct backend ports on Paper/Purpur instances via iptables or UFW, exposing only the proxy facade.',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </svg>
      ),
      watermark: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </svg>
      )
    },
    {
      titleRu: 'Ответственный аудит',
      titleEn: 'Responsible Auditing',
      descRu:
        'Проводите тестирование устойчивости исключительно на серверах, где вы являетесь владельцем или имеете письменное согласие администрации. Используйте умеренное число потоков, чтобы не затронуть внешние узлы дата-центра.',
      descEn:
        'Conduct resilience stress testing strictly on servers you own or possess authorized written permission for. Utilize conservative thread limits to prevent unintended collateral impact on upstream transit.',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
      ),
      watermark: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3">
          <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
      )
    }
  ];

  return (
    <section className="pro-tips-section">
      <div className="section-mono-header">
        <div className="section-mono-title">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <circle cx="12" cy="12" r="3" fill="currentColor" />
          </svg>
          <span>
            {isEn
              ? 'Recommendations and Resilience Guidelines • PRO TIPS'
              : 'Рекомендации и советы по устойчивости • PRO TIPS'}
          </span>
        </div>
      </div>

      <div className="tips-grid ddos-tips-grid">
        {tips.map((tip, index) => (
          <div key={index} className="ddos-tip-card tip-card">
            <div className="ddos-tip-backdrop-icon tip-backdrop-icon" aria-hidden="true">
              {tip.watermark}
            </div>
            <div className="tip-card-inner">
              <div className="tip-icon-header">{tip.icon}</div>
              <h4 className="tip-title">{isEn ? tip.titleEn : tip.titleRu}</h4>
              <p className="tip-description">{isEn ? tip.descEn : tip.descRu}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default DdosProTips;
